// src/hooks/useGetRooms.ts

import { useAppSelector } from "../app/hooks";
import { openapi } from "../../openapi";
import { skipToken } from "@reduxjs/toolkit/query";
import { selectGetMcBimSpacesParams } from "../McBim/McBimSlice";
import { IPartialSpace } from "@backend/src/shared/schemas/schemas";

export function useGetMcbimSpaces(): IPartialSpace[] {
  const args = useAppSelector(selectGetMcBimSpacesParams);
  const { data } = openapi.useGetMcbimSpacesQuery(args ?? skipToken);
  return data ?? [];
}
